import {
  VerticalFeedResponse,
  NPFeedSearchResultResponse,
} from '../../../types'
import { printError } from '../../log'
import { basePath, callAPI } from '../common'
import { callVerticalApi } from './common'

export const getNPFeeds = async () => {
  try {
    const response = await callVerticalApi<VerticalFeedResponse>(
      '/v1/feeds?theme=startup'
    )
    return response.feeds.filter((item) => {
      return !restrictedPublishers.includes(item.publisher)
    })
  } catch (e) {
    printError(e)
    return []
  }
}

export const fetchNPFeedsByCompanyShortname = async (shortname: string) => {
  try {
    const response = await callAPI<NPFeedSearchResultResponse>(
      `${basePath}/companies/${shortname}/np_feeds`
    )
    return response.feeds.filter((item) => {
      return !restrictedPublishers.includes(item.publisher)
    })
  } catch (e) {
    printError(e)
    return []
  }
}

export const fetchNPFeedsByInvestorShortname = async (shortname: string) => {
  try {
    const response = await callAPI<NPFeedSearchResultResponse>(
      `${basePath}/investors/${shortname}/np_feeds`
    )
    return response.feeds.filter((item) => {
      return !restrictedPublishers.includes(item.publisher)
    })
  } catch (e) {
    printError(e)
    return []
  }
}

const restrictedPublishers = [
  'AFPBB News', // https://newspicks.com/user/2062/
  'CNET Japan', // https://newspicks.com/user/2056/
  'ZDNET Japan', // https://newspicks.com/user/2057/
  'Reuters', // https://newspicks.com/user/1002/
]
